<template>
  <div class="textIntro">
    <span class="is-h2 mr-2"
      ><strong>WELCOME | {{ showFirstNameAndRole }} </strong></span
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { isAppTenant } from "@/utils/utils";

export default {
  name: "WelcomeText",
  computed: {
    ...mapGetters({
      userData: "auth/getAuthUserData",
    }),
    showFirstNameAndRole() {
      const names = this.userData.name.split(" ");
      const role = isAppTenant()
        ? null
        : this.userData.roles
        ? this.userData.roles.data
          ? this.userData.roles.data[0].name.toUpperCase()
          : "SALES AGENT"
        : "SALES AGENT";
      return `${names[0].toUpperCase()}` + (role ? ` (${role})` : "");
    },
  },
};
</script>

<style scoped>
.name {
  font-size: 20px;
}
@media screen and (max-width: 480px) {
  .textIntro {
    margin-top: 1rem;
  }
}
</style>
